import { swRequest } from "@sourcewhale/shared/src/svelte/api/sw-request";

export const getCurrencies = (opts = {}) =>
  swRequest(
    {
      path: "/api/currencies/get_all",
      method: "GET",
    },
    opts,
  );
